import React from "react";
import PreOnBoardingbanner from "../../AVHRBanner/Pre_Onboarding_Banner.png";
import preonboadingone from "../../Images/PreOnboardingoneimg.png";
import PostOnboadingOneimg from "../../Images/PostOnboardingoneimg.png";
import "../OurServicesCss/Services.css";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

function PreAndPostOnboarding() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[500px] sm:h-[600px] md:h-[700px] lg:h-[1000px] xl:h-[1100px] banner-H" >
          <img
            src={PreOnBoardingbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
            // style={{minHeight: "80vh"}}
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest avhrProject-bannerTextColour-B">
            <div className="text-bannar max-w-3xl text-left">
              <p className="edu-support-text uppercase ">Our Services</p>

              <h1 className="career-library-heading">Pre & Post 
                Onboarding</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="grid align-items-center px-3 md:px-6 pt-4 md:pt-6">
          <div className="col-12 md:col-6">
            <h1 className="mb-2 avhrProject-h1">
              Pre – Onboarding: Building the Prelude
            </h1>
            <p className="avhrProject-p">
              <b>Commencing on the Talent Quest: </b>
              Prior to the official induction, we embark on a voyage to
              identify, engage, and court potential talents, seeking those rare
              finds that resonate with your organizational DNA
              <br />
              <br />
              <b>Tailoring the Welcome Mat:</b> We understand that first
              impressions are indelible. Hence, we scrupulously customize
              pre-onboarding experiences, setting the stage for a seamless
              transition
            </p>
          </div>

          <div className="col-12 md:col-6 mb-4 md:mb-0">
            <img
              src={preonboadingone}
              alt="About Us"
              className="w-full border-round-lg shadow-4"
            />
          </div>
        </div>

        <div className="grid align-items-center px-3 md:px-6 pt-4 md:pt-6">
          <div className="col-12">
            <h1 className="mb-2 avhrProject-h1">
              Communication and Engagement
            </h1>
            <p className="avhrProject-p">
              We establish effective communication channels with new hires to
              keep them informed, engaged, and excited about their upcoming
              journey with your company. This includes welcome messages,
              instructional materials, and virtual meet-and-greet sessions
            </p>
          </div>
        </div>

        <div className="grid align-items-center px-3 md:px-6 pt-4 md:pt-6">
          <div className="col-12 md:col-6 mb-4 md:mb-0">
            <img
              src={PostOnboadingOneimg}
              alt="About Us"
              className="w-full border-round-lg shadow-4"
            />
          </div>

          <div className="col-12 md:col-6">
            <h1 className="mb-2 avhrProject-h1">
              Post – Onboarding: Building the Prelude
            </h1>
            <p className="avhrProject-p">
              <b>Nurturing a Seamless Transition:</b> Post-onboarding, we assume
              the role of custodians, ensuring the newly minted talents glide
              smoothly into their roles, acquainting them with the intricacies
              of their journey ahead
              <br />
              <br />
              <b>Fostering Engagement and Retention:</b> Beyond the initial
              welcome, we continue to engagement, cultivating a sense of
              belonging, purpose, and fulfilment. We plant the seeds of
              retention that bear fruit in the long term
            </p>
          </div>
        </div>

        <div className="grid justify-content-center align-items-stretch mt-4 gap-4 px-3 md:px-4">
          <div className="col-12 md:col-5 lg:col-5 p-3 ">
            <div
              className="shadow-4 p-4 h-full card-hover-effect"
              style={{ borderRadius: "10px", backgroundColor: "#ffde59" }}
              // backgroundColor: "#B6006B"
            >
              <h1 className="mb-2 avhrProject-h1">
                Shaping Culture: The Sublime Continuum
              </h1>
              <p className="avhrProject-p">
                Designing Cultural Alignment and post-onboarding serve as the
                vanguard for cultural immersion. We embark the narrative,
                intertwining your organizational ethos with the aspirations of
                new talent—building bonds that transcend employment
                <br />
                <br />
                <b>Fostering Organizational Ambassadors:</b> Our nurturing extends 
                beyond onboarding to develop not just employees, but future 
                advocates—individuals who champion your brand and amplify 
                your presence across borders
              </p>
            </div>
          </div>

          <div className="col-12 md:col-5 lg:col-5 p-3">
            <div
              className="shadow-4 p-4 h-full card-hover-effect"
              style={{ borderRadius: "10px", backgroundColor: "#FFB347" }}
            >
              <h1 className="mb-2 avhrProject-h1">
                Feedback Loop: The Sustaining Resonance
              </h1>
              <p className="avhrProject-p">
                <b>Listening and Adapting:</b> Our commitment to excellence
                echoes in our practice of continuous listening.
                <br />
                <br />
                We create feedback loops that help us adapt, evolve, 
                and fine-tune the onboarding process—ensuring it 
                remains a living, breathing entity.
              </p>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              // background: "linear-gradient(120deg, #D2691E, #B0BEC5)",
              background: "linear-gradient(135deg, #FCF709, #E58266)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2 ">
              Smooth onboarding that drives early contribution
            </h2>
            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default PreAndPostOnboarding;
